import React, { useState } from 'react';
import { Grid, Button, InputAdornment } from '@mui/material';
import { DataTable, FormElements, NotifyIcon } from 'web-components';
import AddIcon from '@mui/icons-material/Add';
import T from 'prop-types';
import { useTranslation } from 'react-i18next';
import AddEditBatchDialog from './AddEditBatchDialog';

const DesktopView = ({ props, search, clearAllFields }) => {
  const { t } = useTranslation();
  const [openAddEditBatch, setOpenAddEditBatch] = useState(false);
  const allFieldsEmpty = !search.batchId && !search.machine && !search.recipe;

  const onClickOpenAddEditBatch = () => {
    setOpenAddEditBatch(true);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} sx={{ marginBottom: 3 }}>
          <FormElements.TextField
            label={t('batch_records.overview.search')}
            bgcolor="#FFFFFF"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ position: 'absolute', right: '12px', bottom: '22px' }}>
                  <NotifyIcon iconName="search" fontSize="default" color="primary" />
                </InputAdornment>
              )
            }}
            onChange={e => search.handleSearchBatchID(e.target.value)}
            value={search.batchId}
            data-testid="batch-records-list-batchid-field"
            sx={{
              width: { xs: '100%', md: '100%' }
            }}
          />
        </Grid>
        <Grid item xs={12} md={3} sx={{ marginBottom: 3 }}>
          <FormElements.TextField
            label={t('batch_records.overview.search_machine')}
            bgcolor="#FFFFFF"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ position: 'absolute', right: '12px', bottom: '22px' }}>
                  <NotifyIcon iconName="search" fontSize="default" color="primary" />
                </InputAdornment>
              )
            }}
            onChange={e => search.handleSearchMachine(e.target.value)}
            value={search.machine}
            data-testid="batch-records-list-machinename-field"
            sx={{
              width: { xs: '100%', md: '100%' }
            }}
          />
        </Grid>
        <Grid item xs={12} md={3} sx={{ marginBottom: 3 }}>
          <FormElements.TextField
            label={t('batch_records.overview.search_recipe')}
            bgcolor="#FFFFFF"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ position: 'absolute', right: '12px', bottom: '22px' }}>
                  <NotifyIcon iconName="search" fontSize="default" color="primary" />
                </InputAdornment>
              )
            }}
            onChange={e => search.handleSearchRecipe(e.target.value)}
            value={search.recipe}
            data-testid="batch-records-list-recipe-field"
            sx={{
              width: { xs: '100%', md: '100%' }
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Grid container alignItems="center" spacing={2} sx={{ marginBottom: 3 }}>
            <Grid item xs={6}>
              <Button
                data-testid="clear-filter-button"
                variant="text"
                sx={{ height: '56px' }}
                disabled={allFieldsEmpty}
                onClick={clearAllFields}
              >
                {t('default_actions.clear_filter')}
              </Button>
            </Grid>
            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                data-testid="add-batch-button"
                variant="contained"
                sx={{
                  height: '56px',
                  minWidth: '110px'
                }}
                startIcon={<AddIcon />}
                onClick={onClickOpenAddEditBatch}
              >
                {t('batch_records.new_batch')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DataTable data-testid="batch-records-table" hover {...props} />
      <AddEditBatchDialog open={openAddEditBatch} setOpen={setOpenAddEditBatch} />
    </>
  );
};

DesktopView.propTypes = {
  props: T.shape({}).isRequired,
  search: T.shape({
    batchId: T.string.isRequired,
    machine: T.string.isRequired,
    recipe: T.string.isRequired,
    handleSearchBatchID: T.func.isRequired,
    handleSearchMachine: T.func.isRequired,
    handleSearchRecipe: T.func.isRequired
  }).isRequired,
  clearAllFields: T.func.isRequired
};

export default DesktopView;
